export const logoutAction = () => {
    return async (dispatch) => {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        dispatch({
            type:'LOGOUT_DONE'
        })
    }
}